<nav mat-tab-nav-bar class="tab-custom-overflow">
  <a mat-tab-link [routerLink]="['/ordre']" routerLinkActive="active" routerLinkActiveOptions="{exact:true}">Ordre</a>
  <a mat-tab-link [routerLink]="['/foraeldreloese']" routerLinkActive="active" routerLinkActiveOptions="{exact:true}">Partneroprettet</a>
</nav>
